export const GET_BACKGROUND = "GET_BACKGROUND";
export const CREATE_NEW_BACKGROUND = "CREATE_NEW_BACKGROUND";
export const EDIT_BACKGROUND = "EDIT_BACKGROUND";
export const DELETE_BACKGROUND = "DELETE_BACKGROUND";


export const OPEN_BACKGROUND_DIALOG = "OPEN_BACKGROUND_DIALOG";
export const CLOSE_BACKGROUND_DIALOG = "CLOSE_BACKGROUND_DIALOG";
